import { Form } from "@unform/web";
import React from "react";

import { DigitSeparated } from "Components/Admin/Form/Input/Variants";
import Modal from "Components/Common/Modal";
import Button from "Components/Global/Buttons";

import * as S from "./styles";

const TwoFactorModal = ({
  submit,
  close,
  loading,
  open,
  setShouldShowModal,
  submitText,
  cancelText,
}) => {
  return (
    <Modal
      open={open}
      title="Autenticação em duas etapas"
      text="Foi enviado um código de verificação para o seu e-mail. Por favor, verifique sua caixa de entrada e insira o código abaixo."
      dismiss={() => setShouldShowModal(false)}
      allowDismiss={false}
      showButtons={false}
      onDismiss={close}
      onSubmit={submit}
    >
      <Form onSubmit={submit}>
        <S.Wrapper>
          <DigitSeparated
            type="digit-separated"
            required
            name="verification_code"
            label="Código de verificação"
            placeholder="9"
            mask="9"
            digits={6}
          />

          <S.ButtonsWrapper>
            <Button
              type="button"
              onClick={close}
              outline
              disabled={loading}
              text={cancelText}
            />
            <Button
              type="submit"
              variant="primary"
              disabled={loading}
              text={submitText}
            />
          </S.ButtonsWrapper>
        </S.Wrapper>
      </Form>
    </Modal>
  );
};

export default TwoFactorModal;
